export default "__VITE_ASSET__QX9O9owb__";